module.exports = __webpack_public_path__ + "media/components/src/assets/images/embellishments/book-details/book_detail_01-63c18522f4fc45822bc7badb3861c9ca.png";